import MedicationTime from './MedicationTime.jsx';

export default MedicationTime;